import * as t from 'io-ts'

export const PopularVoteVisibility = t.union([t.literal('inactive'), t.literal('preview'), t.literal('visible')])
export type PopularVoteVisibility = t.TypeOf<typeof PopularVoteVisibility>

export const mkPopularVoteVisibility = (x: PopularVoteVisibility): PopularVoteVisibility => x

export interface PopularVoteVisibilityMatcher<T> {
  inactive: T
  preview: T
  visible: T
}

export const casePopularVoteVisibility =
  <T>(m: PopularVoteVisibilityMatcher<T>) =>
  (vis: PopularVoteVisibility): T =>
    m[vis]
